// Modules
import React from "react";
import HubspotForm from "react-hubspot-form";
import PropTypes from "prop-types";
import cx from "classnames";

// Components
import Button from "../button";

// Styles
import * as styles from "./form.module.scss";

// Constants
import { builderType } from "../../constants/constants";

const Form = (props) => {
  const {
    bgColor,
    formContent,
    formId,
    portalId,
    className,
    anchorId,
    noForm,
    _type,
    ctaBtnLink,
  } = props;
  const wrapperStyle = { backgroundColor: bgColor };

  // Inline style added to both <h2> elements
  const getAnchorTitle = (title) =>
    anchorId ? (
      <h2 id={anchorId} className={cx("raleway-lg-title", styles.title)}>
        {title}
      </h2>
    ) : (
      <h2 className={cx("raleway-lg-title", styles.title)}>
        {title}
      </h2>
    );

  const getBtnLink = (position) => {
    if (!ctaBtnLink.label) {
      return null;
    }
    return position === "full" ? (
      <Button link={ctaBtnLink.url} {...ctaBtnLink}>
        {ctaBtnLink.label}
      </Button>
    ) : (
      <div style={{ display: "flex", justifyContent: position, width: "90%" }}>
        <Button link={ctaBtnLink.url} {...ctaBtnLink}>
          {ctaBtnLink.label}
        </Button>
      </div>
    );
  };

  return (
    <div
      className={cx({
        [styles.formWrapper]: !className,
        [className]: className,
      })}
      style={wrapperStyle}
    >
      {formContent?.titleText && getAnchorTitle(formContent.titleText)}
      {formContent?.subtitleText && <p>{formContent.subtitleText}</p>}
      {builderType.cta !== _type ? (
        <div className={styles.form}>
          <HubspotForm
            formId={formId}
            portalId={portalId}
            onSubmit={() => console.log("Submit!")}
          />
        </div>
      ) : !noForm ? (
        <div className={styles.form}>
          <HubspotForm
            formId={formId}
            portalId={portalId}
            onSubmit={() => console.log("Submit!")}
          />
        </div>
      ) : (
        getBtnLink(ctaBtnLink.btnPosition)
      )}
    </div>
  );
};

Form.propTypes = {
  bgColor: PropTypes.string,
  formContent: PropTypes.shape({
    subtitleText: PropTypes.string,
    titleText: PropTypes.string,
  }),
  formId: PropTypes.string.isRequired,
  portalId: PropTypes.string.isRequired,
  className: PropTypes.string,
  anchorId: PropTypes.string,
  _type: PropTypes.string,
  noForm: PropTypes.bool,
  ctaBtnLink: PropTypes.shape({
    btnPosition: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
    _type: PropTypes.string,
    newTab: PropTypes.bool,
    newTabLink: PropTypes.string,
  }),
};

Form.defaultProps = {
  bgColor: "",
  className: "",
  anchorId: "",
  noForm: true,
  type: "",
  formContent: {
    subtitleText: "",
    titleText: "",
  },
  ctaBtnLink: {
    btnPosition: "full",
    label: "",
    type: "btn-pink",
    url: "",
    _type: "",
    newTabLink: "",
    newTab: false,
  },
};

export default Form;
